import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import styled from 'styled-components'

const ManualSkeletonContainer = styled.div`
	padding: 120px 25px 40px;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	@media (min-width: 768px) {
		align-items: center;
		width: 713px;
		margin: 0 auto;
	}

	@media (min-width: 1024px) {
		width: 906px;
	}
`

const StyledSkeleton = styled(Skeleton)`
	&.react-loading-skeleton {
		--base-color: var(--skeleton-base-color, #e0e0e0);
		--highlight-color: var(--skeleton-highlight-color, #e0e0e0);
		background-color: var(--skeleton-base-color, #e0e0e0) !important;
		background-image: linear-gradient(
			90deg,
			var(--skeleton-base-color, #e0e0e0),
			var(--skeleton-base-color, #e0e0e0) 25%,
			var(--skeleton-highlight-color, #f5f5f5) 50%,
			var(--skeleton-base-color, #e0e0e0) 75%,
			var(--skeleton-base-color, #e0e0e0)
		);
		background-size: 200% 100%;
		animation: shimmer 2.5s infinite;
	}

	@keyframes shimmer {
		0% {
			background-position: -200% 0;
		}
		100% {
			background-position: 200% 0;
		}
	}
`

const DetailsRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 21px;
	gap: 16px;
	width: 100%;

	@media (min-width: 768px) {
		width: 440px;
	}
`

const DetailItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;

	@media (min-width: 768px) {
		align-items: center;
	}
`

const MemoryTrackBox = styled.div`
	width: 100%;
	padding: 28px 20px;
	border: 1px solid var(--border-color-light, #e8e8e8);
	border-radius: 4px;
	margin-top: 24px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	@media (min-width: 768px) {
		align-items: center;
		padding: 40px 21px;
		margin-top: 32px;
	}
`

const BodySection = styled.div`
	width: 100%;
	margin-top: 56px;
	padding: 0 20px;

	@media (min-width: 768px) {
		margin-top: 64px;
		padding: 0;
	}
`

const ManualSkeleton = () => {
	return (
		<ManualSkeletonContainer>
			{/* Theme label */}
			<StyledSkeleton width={180} height={14} style={{ marginBottom: '12px' }} />

			{/* Topic title */}
			<StyledSkeleton width='90%' height={28} style={{ marginBottom: '6px', maxWidth: '500px' }} />
			<StyledSkeleton width='60%' height={28} style={{ maxWidth: '340px' }} />

			{/* Lesson / Read Time / Date row */}
			<DetailsRow>
				<DetailItem>
					<StyledSkeleton width={80} height={12} />
					<StyledSkeleton width={60} height={16} />
				</DetailItem>
				<DetailItem>
					<StyledSkeleton width={80} height={12} />
					<StyledSkeleton width={70} height={16} />
				</DetailItem>
				<DetailItem>
					<StyledSkeleton width={90} height={12} />
					<StyledSkeleton width={100} height={16} />
				</DetailItem>
			</DetailsRow>

			{/* Text to read */}
			<StyledSkeleton width={160} height={12} style={{ marginTop: '25px', marginBottom: '13px' }} />
			<StyledSkeleton width='75%' height={14} style={{ maxWidth: '320px' }} />

			{/* Header image */}
			<StyledSkeleton
				width='100%'
				height={236}
				style={{ marginTop: '23px', borderRadius: '0' }}
			/>

			{/* Memory track box */}
			<MemoryTrackBox>
				<StyledSkeleton width={120} height={32} style={{ borderRadius: '29px' }} />
				<StyledSkeleton width='90%' height={14} style={{ marginTop: '16px', maxWidth: '500px' }} />
				<StyledSkeleton width='80%' height={14} style={{ marginTop: '8px', maxWidth: '440px' }} />
				<StyledSkeleton width='50%' height={14} style={{ marginTop: '8px', maxWidth: '280px' }} />
			</MemoryTrackBox>

			{/* Body content */}
			<BodySection>
				{/* Section heading */}
				<StyledSkeleton width={200} height={24} style={{ marginBottom: '20px' }} />

				{/* Paragraph lines */}
				<StyledSkeleton width='100%' height={14} style={{ marginBottom: '12px' }} />
				<StyledSkeleton width='100%' height={14} style={{ marginBottom: '12px' }} />
				<StyledSkeleton width='100%' height={14} style={{ marginBottom: '12px' }} />
				<StyledSkeleton width='85%' height={14} style={{ marginBottom: '28px' }} />

				<StyledSkeleton width='100%' height={14} style={{ marginBottom: '12px' }} />
				<StyledSkeleton width='100%' height={14} style={{ marginBottom: '12px' }} />
				<StyledSkeleton width='70%' height={14} style={{ marginBottom: '28px' }} />

				{/* Another heading */}
				<StyledSkeleton width={240} height={24} style={{ marginBottom: '20px' }} />

				<StyledSkeleton width='100%' height={14} style={{ marginBottom: '12px' }} />
				<StyledSkeleton width='100%' height={14} style={{ marginBottom: '12px' }} />
				<StyledSkeleton width='100%' height={14} style={{ marginBottom: '12px' }} />
				<StyledSkeleton width='60%' height={14} />
			</BodySection>
		</ManualSkeletonContainer>
	)
}

export default ManualSkeleton
